/**
 * Busca da plataforma: filtro NO CLIENTE, sobre a lista que já veio.
 *
 * Nenhum `queryKey` muda e nenhum endpoint novo existe por causa da busca — as
 * listas do app cabem na memória do navegador, e um round-trip por tecla no
 * campo seria pior em 4G no meio da roça do que filtrar o array aqui.
 *
 * Comparação sem acento e sem caixa: "joao" tem que achar "João", porque é
 * assim que se digita num teclado de celular com pressa.
 */

/**
 * "São José" → "sao jose".
 *
 * O corte dos acentos é `[\u0300-\u036f]` (o bloco Combining Diacritical Marks),
 * e não `\p{Diacritic}` com flag `u`: o `tsconfig` do repo não declara `target`,
 * então o typecheck do CI roda em ES3 e a flag `u` é TS1501 ali. Depois do
 * `normalize("NFD")` o acento já está separado da letra — o intervalo pega todos.
 */
export function normalizar(texto: string): string {
  return texto
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();
}

/**
 * `true` se QUALQUER um dos campos contém o termo. Campos nulos são ignorados;
 * termo vazio passa tudo — quem chama não precisa testar antes.
 */
export function combina(termo: string, ...campos: (string | null | undefined | number)[]): boolean {
  const alvo = normalizar(termo);
  if (!alvo) return true;
  for (const campo of campos) {
    if (campo === null || campo === undefined) continue;
    if (normalizar(String(campo)).includes(alvo)) return true;
  }
  return false;
}
